import { call, put, takeLatest } from "redux-saga/effects";
import { PettyCashierVatReviewAction } from "../../actions";
import * as types from "../../actions/actionTypes";
import * as vatReviewApi from "../../api/vatReview/pettyCashierVatReview";
import GetFilter from "../../hocs/vatReviewReport/components/filter/tools/getFilter";
import { SetMessage } from "../../assets/errorMessages";

export function* pettyCashierWatcherVatReview() {
  yield takeLatest(types.PETTY_CASHIER_VAT_REVIEW_REQUEST, worker);
}

async function fetchList(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  return vatReviewApi.getList(page_number, GetFilter());
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(PettyCashierVatReviewAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierVatReviewAction.getFailure(message));
  }
}
